import React from "react";

export default function Banner(props) {
    const url = props.image
    return (
        <section className="banner-section">
            <div className="bg">
                <img src={url} />
                <div className="text-wrapper">
                    <h1>
                        {props.data}
                    </h1>
                </div>
                <div className="bg-color"></div>
            </div>
        </section>
    )
}